module.exports = __webpack_public_path__ + "static/media/JosefinSlab-SemiBold.bba83803.ttf";